export default __webpack_public_path__ + "static/media/p-6.1c3145eb.png";